// Channel IDs sourced from the production herald-bot .env. Update here when
// the bot's channel layout changes.
export const ANNOUNCEMENT_CHANNEL_ID = '806503431861829693';

// Used for the Create dropdown (Announcement only, per spec). The form
// dynamically injects the record's channelId on Edit when it isn't here, so
// legacy rows targeting other channels still show the value selected.
export const SCHEDULED_MESSAGE_CHANNELS = [
  { id: ANNOUNCEMENT_CHANNEL_ID, name: 'Announcement' },
];

// Broader lookup so the list and the edit dropdown show friendly names for
// any channel that already exists in the DB. Sourced from herald-bot env.
export const SCHEDULED_MESSAGE_CHANNEL_LABEL_MAP: { [id: string]: string } = {
  '806503431861829693': 'Announcement',
  '927495063645327360': 'Admin Command',
  '1041787411816005642': 'Announcer Command',
  '917444852898201640': 'Mod Command',
  '1060509435644088421': 'Community Command',
  '806501854233624576': 'General Story',
  '891224034434502686': 'Empire Story',
  '891227200081231893': 'Federation Story',
  '891227311561637939': 'Union Story',
  '1006519279061053510': 'Lore Codex',
  '945260469868961832': 'Rewards',
  '961124551306133564': 'Content Creator Terms',
  '1333387309776769097': 'Language Selection',
  '1333403671664398357': 'Logs',
  '921385189081514014': 'Admin Chat',
};

export const getChannelLabel = (channelId?: string | null): string => {
  if (!channelId) return '-';
  return (
    SCHEDULED_MESSAGE_CHANNEL_LABEL_MAP[channelId] ?? `Channel ${channelId}`
  );
};

export type ScheduledMessage = {
  id: number | string;
  time: string | Date;
  content: string;
  discordId: string | null;
  active: boolean;
  channelId: string | null;
  botId: string | null;
  files: string | null;
};

// The Herald bot stores/sends times in UTC (mirrors the !scheduleMessage epoch
// flow). These helpers make the picker show and save the UTC wall-clock so what
// marketing types is exactly what gets posted, regardless of browser timezone.
export const formatTimeForInput = (value?: string | Date | null): string => {
  if (!value) return '';
  const date = new Date(value);
  if (isNaN(date.getTime())) return '';

  return date.toISOString().slice(0, 16);
};

export const parseTimeAsUtc = (value?: string | null): string | null => {
  if (!value) return null;
  const withSeconds = value.length === 16 ? `${value}:00` : value;
  const date = new Date(`${withSeconds}Z`);

  return isNaN(date.getTime()) ? null : date.toISOString();
};

export const formatTimeForDisplay = (value?: string | Date | null): string => {
  if (!value) return '-';
  const date = new Date(value);
  if (isNaN(date.getTime())) return '-';

  return `${date.toISOString().slice(0, 16).replace('T', ' ')} UTC`;
};
